module.exports = __webpack_public_path__ + "img/bank-bsi.d051b69d.png";